import { useLocation } from "react-router-dom";
import { MemberSidebar } from "@/components/layout/MemberSidebar";
import { MemberHeader } from "@/components/layout/MemberHeader";
import { IntakeForm } from "@/components/intake/IntakeForm";

interface IntakePageState {
  editData?: Record<string, any>;
  patientId?: string;
}

export default function IntakePage() {
  const location = useLocation();
  const state = (location.state as IntakePageState) || {};

  return (
    <div className="min-h-screen bg-background">
      <MemberSidebar />
      <div className="ml-64">
        <MemberHeader />
        <main className="p-6">
          <div className="mb-6">
            <h1 className="font-display text-3xl font-bold text-foreground">
              {state.patientId ? "Edit My Information" : "Patient Intake"}
            </h1>
            <p className="mt-1 text-muted-foreground">
              {state.patientId
                ? "Review and update your personal, insurance, and medical information"
                : "Complete this new patient evaluation form for Medicare or Medicaid services"}
            </p>
          </div>
          <IntakeForm
            editData={state.editData}
            patientId={state.patientId}
            redirectTo="/member/profile"
          />
        </main>
      </div>
    </div>
  );
}
